import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    private checkLogin(url: string) {
        if (this.authService.isAuthenticated) {
            if (url === '/login') {
                this.router.navigate(['/']);
            }
            return true;
        }

        if (url !== '/login') {
            this.router.navigate(['/login']);
            return false;
        }
        return true;
    }

    constructor(protected authService: AuthService, protected router: Router) {}

    canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const url = state.url;
        const validLogin = this.checkLogin(url);
        if (!validLogin) {
            return of(true);
        }
        return true;
    }
}
